import React, { useContext, useRef, useState } from "react";
import { Layout } from "react-grid-layout";
import { useSelector } from "react-redux";
import { selectOrganization } from "go-security/services/organizations/selectors";
import { DashboardContext } from "../../index";
import { DashboardGridItem, DashboardType } from "../../services/types";
import { shouldDisplayCallRecorderBox } from "../../utils/utils";
import DraggableDashboardAlerts from "../Alerts/DashboardAlerts";
import { DraggableDashboardCallRecorder } from "../CallRecorder/DashboardCallRecorder";
import DraggableDashboardClientsDetailsInformations from "../ClientsDetails/DashboardClientsDetails";
import DraggableDashboardLive from "../Live/DashboardLive";

interface Props {
	loading: boolean;
}

const DashboardGeneralTab = ({ loading }: Props) => {
	const ref = useRef<HTMLDivElement>(null);
	const [state, setState] = useState<Layout[]>([]);
	const { dashboardType } = useContext(DashboardContext);
	const organization = useSelector(selectOrganization);
	const displayCallRecorderBox = shouldDisplayCallRecorderBox(
		dashboardType,
		organization?.more?.installed_app_providers
	);

	return (
		<>
			{dashboardType === DashboardType.ORGANIZATION && (
				<DraggableDashboardAlerts key={DashboardGridItem.ALERTS} ref={ref} setNonMobileLayout={setState} />
			)}
			<DraggableDashboardClientsDetailsInformations
				key={DashboardGridItem.CLIENT_DETAILS}
				ref={ref}
				setNonMobileLayout={setState}
			/>
			{displayCallRecorderBox && (
				<DraggableDashboardCallRecorder key={DashboardGridItem.CALL_RECORDER} setNonMobileLayout={setState} />
			)}
			{dashboardType === DashboardType.ORGANIZATION && (
				<DraggableDashboardLive
					loading={loading}
					key={DashboardGridItem.LIVE}
					ref={ref}
					setNonMobileLayout={setState}
				/>
			)}
		</>
	);
};

export default DashboardGeneralTab;
